module.exports = __webpack_public_path__ + "fonts/d2a55d331bdd1a7ea97a8a1fbb3c569c.woff";